import { hideFullScreenOverlay, showFullScreenOverlay } from '../../layout/fullScreenOverlay';
import { acceptPolicy, AcceptPolicyRequest } from '../policy/acceptPolicyRequest';
import { getUserSuid } from './getUserSuid';
import { AcceptPolicyResponse } from '../../api/hub-responses/accept-policy-response';
import { PolicyInfo } from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/get-game-start-data-request';
import { Localization } from '../../localization/localization';
import { PolicyType, policyTypePopupIdMap } from '../../constants/PolicyType';
import { Url } from './url';
import { ErrorSmallPopup } from '../../popups/errorSmallPopup';

export const PolicyDialog = {
    $current_policy_popup: void (0) as JQuery<HTMLElement>,
    block_button: void (0) as boolean,
    policyInfo: void (0) as PolicyInfo,
    $accept_policy_popup: $('#accept_policy_popup'),
    $notify_policy_popup: $('#notify_policy_popup'),
    setGetUserReadyFlag: (): void => {
        window.app.flags.get_user_ready = true;
    },
    checkPolicyAccept: (): void => {
        PolicyDialog.policyInfo = window.app.getGameStartDataResponse.policy_info;
        delete window.app.getGameStartDataResponse.policy_info;

        PolicyDialog.$current_policy_popup = PolicyDialog.policyInfo.isNotification === true
            ? PolicyDialog.$notify_policy_popup
            : PolicyDialog.$accept_policy_popup;

        if (PolicyDialog.policyInfo.accepted === true) {
            PolicyDialog.setGetUserReadyFlag();
            return;
        }

        $('button', PolicyDialog.$current_policy_popup).on('click', () => {
            if (
                typeof PolicyDialog.block_button === 'undefined' ||
                PolicyDialog.block_button === false
            ) {
                PolicyDialog.block_button = true;
                PolicyDialog.acceptNewPolicy();
            }
        });

        $('.content', PolicyDialog.$current_policy_popup).html(PolicyDialog.getHtmlView());
        PolicyDialog.$current_policy_popup.show();
        if (PolicyDialog.policyInfo.isNotification === true) {
            PolicyDialog.setGetUserReadyFlag();
            showFullScreenOverlay();
        }
    },
    getHtmlView: (): string => {
        const template = `
            <a href="%policyUrl%"
                class="font2 link js-click"
                data-id="%policyId%"
                data-hideclass="document_popup"
                data-url="%policyPath%"
                data-handler="popup"
            >
                %policyTitle%
            </a>
        `;
        const links = [];

        for (const policy of PolicyDialog.policyInfo.policy_objects) {
            const policyLabel = policyTypePopupIdMap.get(policy.id as PolicyType);
            const placeholders = {
                '%policyId%': policyLabel,
                '%policyUrl%': Url.getFullLangUrl(`#${policyLabel}`),
                '%policyPath%': `/policies/${policyLabel}`,
                '%policyTitle%': policy.text
            };

            let link = template;
            Object.entries(placeholders).forEach(([key, value]) => {
                link = link.replace(new RegExp(key, 'g'), value);
            });

            links.push(link);
        }

        const linksStr = links.join(', ');
        const buttonText = Localization._n('keyin2tables.accept_button');

        let result = Localization._n(
            'keyin2tables.accept_popup_text',
            {
                br: '<br/>',
                links: linksStr,
                button_text: buttonText
            }
        );

        if (PolicyDialog.policyInfo.isNotification === true) {
            result = result.split('<br')[0];
        }

        return result;
    },
    showErrorAndReload: (): void => {
        PolicyDialog.$current_policy_popup.hide();
        hideFullScreenOverlay();

        const errorSmallPopup = ErrorSmallPopup.getInstance();
        errorSmallPopup.setMessage(Localization._n('feedback_common_error'));
        errorSmallPopup.setButtonText(Localization._n('ecommpay.button_to_retry'));
        errorSmallPopup.show();
        errorSmallPopup.setCallback(() => {
            errorSmallPopup.hide();
            location.reload();
        });
    },
    acceptNewPolicy: async() => {
        const policyIds = [];

        for (const policy of PolicyDialog.policyInfo.policy_objects) {
            policyIds.push(policy.id);
        }

        const data: AcceptPolicyRequest = {
            suid: getUserSuid(false),
            token: window.app.config.user_auth_token,
            policy_ids: policyIds
        };

        let errorText = 'bad response from server. response: ';
        try {
            const response: AcceptPolicyResponse = await acceptPolicy(data);

            if (response.status !== 1) {
                errorText += JSON.stringify(response);
                window.Sentry.captureException(new Error(errorText));
                PolicyDialog.showErrorAndReload();
                return;
            }
        } catch (error) {
            errorText += JSON.stringify(error);
            window.Sentry.captureException(new Error(errorText));
            PolicyDialog.showErrorAndReload();
            return;
        }

        PolicyDialog.setGetUserReadyFlag();
        PolicyDialog.$current_policy_popup.hide();
        hideFullScreenOverlay();
    }
};

$(() => {
    PolicyDialog.$accept_policy_popup = $('#accept_policy_popup');
    PolicyDialog.$notify_policy_popup = $('#notify_policy_popup');
});
